import { render, staticRenderFns } from "./InputPrice.vue?vue&type=template&id=71393cfc&scoped=true&"
import script from "./InputPrice.vue?vue&type=script&lang=js&"
export * from "./InputPrice.vue?vue&type=script&lang=js&"
import style0 from "./InputPrice.vue?vue&type=style&index=0&id=71393cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71393cfc",
  null
  
)

export default component.exports